import { createFileRoute } from "@tanstack/react-router";
import { AccountPanel } from "~/components/account/account-panel";
export const Route = createFileRoute("/_authed/settings/security")({
  component: () => <AccountPanel />,
});
